export default "__VITE_ASSET__DYshN2ZW__"